import React, { Component } from 'react'

export class Vendor_form extends Component {
  render() {
    return (
      <div>Vendor_form</div>
    )
  }
}

export default Vendor_form